import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/transporters',
    name: 'transporters',
    component: () => import('@/views/restricted/transporters/TransporterLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_READ_PERMISSION'],
      menuSelected: 'transporters'
    }
  },
  {
    path: '/transporters/expressists/create',
    name: 'expressistCreate',
    component: () => import('@/views/restricted/transporters/expressist/ExpressistCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_CREATE_PERMISSION'],
      menuSelected: 'transporters'
    }
  },
  {
    path: '/transporters/expressists/:expressistId/edit',
    name: 'expressistUpdate',
    component: () => import('@/views/restricted/transporters/expressist/ExpressistUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_UPDATE_PERMISSION'],
      menuSelected: 'transporters'
    }
  },
  {
    path: '/transporters/expressists/:expressistId',
    name: 'expressistDetail',
    component: () =>
      import('@/views/restricted/transporters/expressist/ExpressistDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_READ_PERMISSION'],
      menuSelected: 'transporters'
    }
  },
  {
    path: '/transporters/expressists/:expressistId/connexions/create',
    name: 'expressistConnexionCreate',
    component: () =>
      import(
        '@/views/restricted/transporters/expressist/connexion/ExpressistConnexionCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_CREATE_PERMISSION'],
      menuSelected: 'transporters'
    }
  },
  {
    path: '/transporters/expressist-connexions/:expressistConnexionId/edit',
    name: 'expressistConnexionUpdate',
    component: () =>
      import(
        '@/views/restricted/transporters/expressist/connexion/ExpressistConnexionUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_UPDATE_PERMISSION'],
      menuSelected: 'transporters'
    }
  },
  {
    path: '/transporters/expressist-connexions/:expressistConnexionId',
    name: 'expressistConnexionDetail',
    component: () =>
      import(
        '@/views/restricted/transporters/expressist/connexion/ExpressistConnexionDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_READ_PERMISSION'],
      menuSelected: 'transporters'
    }
  },
  {
    path: '/transporters/expressist-connexions/:expressistConnexionId/links/create',
    name: 'expressistLinkCreate',
    component: () =>
      import(
        '@/views/restricted/transporters/expressist/connexion/link/ExpressistLinkCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_TRANSPORTER_CREATE_PERMISSION'],
      menuSelected: 'transporters'
    }
  }
]
